export enum StepIds {
    propertyInformation = 'property-information',
    propertyDescription = 'property-description',
    propertyPhotos = 'property-photos',
    propertyPromote = 'property-promote',
    propertySummary = 'property-summary'
}
